<template>
  <div>
    <div v-if="expenses.length" class="flex flex_gap_10 mb-2">
      <div class="border p-1" v-for="(exp, e) in getSummaryExpenses()">{{ exp.currency_title }}: <strong>{{
          exp.sum
        }}</strong> ({{ exp.count }})
      </div>
    </div>
    <div class="row block" v-for="(exp, i) in editExpenses" :key="exp.id">
      <div class="p-0 col-md-5 flex">
        <template v-if="$currentRole !== 'admin' && expensesUsers">
          <select v-model="exp.user_id" class="form-control">
            <option v-for="u in expensesUsers" :value="u.id">{{ u.name }}</option>
            <option value="0">Администрация</option>
          </select>
        </template>
        <template v-else>
          <div class="created_info">
            <p>{{
                exp.to_division_id ? mixinGetDivisionName($AllDivisions[exp.to_division_id]) : 'Администрация'
              }}</p>
            <template v-if="users && users[exp.user_id]">
              <p>{{ (users && users[exp.user_id]) || exp.user_id || 'Админ' }}</p>
            </template>
            <template v-else>
              <p>
                <UserName :id="exp.user_id"/>
              </p>
            </template>
            <p class="text-muted">{{ exp.created_at ? printDate(exp.created_at) : "новый расход" }}</p>
          </div>
        </template>
        <select v-if="(chiefRunners ?? []).length > 1" v-model="exp.user_id" class="form-control">
          <option :value="null" disabled>Выберите пользователя</option>
          <option v-for="u in chiefRunners" :value="u.id">{{ u.name }}</option>
        </select>
        <select
          v-model="exp.type_id"
          :disabled="exp.to_delete || exp.disabled"
          class="form-control"
        >
          <option value="0" disabled>Выберите тип расхода</option>
          <option v-for="(type, id) in allTypes" :value="id"
                  v-if="(exp.id && exp.user_id === $currentUID && allowExpensesTypes.includes(+id)) || (exp.id && exp.user_id !== $currentUID) || $currentRole === 'admin' || allowExpensesTypes.includes(+id)">
            {{ type }}
          </option>
        </select>
        <input v-if="false && !+division" type="text" class="w_120 form-control" disabled
               :value="exp.affect_saldo ? '' : 'н/в прибыль'">
      </div>
      <div class="p-0 col-md-4">
        <input
          type="text"
          v-model="exp.comment"
          :disabled="exp.to_delete || exp.disabled"
          placeholder="Комментарий"
          class="form-control"
        />
      </div>
      <div class="p-0 col-md-3">
        <div class="flex">
          <input
            type="text"
            v-model="exp.sum"
            :disabled="exp.to_delete || exp.disabled"
            placeholder="Сумма"
            class="form-control"
          />
          <select
            v-model="exp.currency_id"
            :disabled="exp.to_delete || exp.disabled"
            class="form-control"
          >
            <option value="0" disabled>Выберите валюту</option>
            <option v-for="curr in $AllCurrencies" :value="curr.id"
                    v-if="exp.id || $currentRole === 'admin' || allowCurrencies.includes(+curr.id)"
            >{{
                curr.currency
              }}
            </option>
          </select>
          <button
            v-if="!exp.disabled"
            @click="exp.to_delete = !exp.to_delete"
            class="btn btn-danger"
          >
            <i class="icon-fa icon-fa-remove"></i>
          </button>
        </div>
      </div>
      <div v-if="false && !exp.id" class="flex">
        <label for="check_1_a" class="w_300">
          <input type="checkbox" class="from-control pointer" @change="(e) => updateType(e, i)" id="check_1_a">
          сделать регулярным
        </label>
        <div class="input-group" v-if="exp.pass_type === 2">
          <div class="input-group-prepend">
            <span class="input-group-text">повторять каждые</span>
          </div>
          <input type="number" v-model="exp.extra_data.period" class="form-control w_110">
          <div class="input-group-append">
            <select v-model="exp.extra_data.period_type" class="form-control">
              <option value="days">дней</option>
              <option value="month">месяцев</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-content-between p-t-10">
      <button @click="addNew" class="btn btn-info">Добавить расход</button>
      <vue-ladda
        @click="save"
        button-class="btn btn-success"
        data-style="zoom-in"
        :loading="loading"
      >Сохранить расходы
      </vue-ladda>
    </div>
    <!--    {{expenses}}-->
  </div>
</template>

<script>
import api from "@/api";
import SelectCity from "@/components/cities/SelectCity";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import {diff} from "deep-object-diff";
import UserName from "@/components/users/UserName.vue";

export default {
  components: {
    UserName,
    SelectCity,
    VueLadda
  },
  props: [
    "types",
    "division",
    "users",
    "expenses",
    "updateExpenses",
    "userId",
    "date",
    "currencies",
    'expensesUsers',
    'notConfirmedExpenses',
    'chiefRunners',
  ],
  data() {
    return {
      editExpenses: [],
      loading: false,
      allTypes: {},
      allowExpensesTypes: [],
      allowCurrencies: [],
    };
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  watch: {
    expenses: {
      handler: function (val) {
        this.cloneExpenses();
      }
    },
    editExpenses: {
      handler: function (val, oldVal) {
        this.editExpenses.forEach((exp, i) => {
          if (exp.id) {
            if (
              exp.type_id != this.expenses[i].type_id ||
              exp.comment != this.expenses[i].comment ||
              exp.sum != this.expenses[i].sum ||
              exp.user_id != this.expenses[i].user_id ||
              exp.currency_id != this.expenses[i].currency_id
            ) {
              this.editExpenses[i].changed = true;
            }
          }
        });
      },
      deep: true
    }
  },
  async mounted() {
    this.cloneExpenses();
    if (!this.types) {
      await this.getTypes();
    } else {
      this.allTypes = {...this.types};
    }
    this.allowExpensesTypes = this.$UserDetails.find((d) => d.alias === 'allowed_expenses')?.details ?? [];
    this.allowCurrencies = this.$UserDetails.find((d) => d.alias === 'allowed_expenses_currencies')?.details ?? [];
  },
  methods: {
    getSummaryExpenses() {
      return this.expenses.reduce((acc, e) => {
        if (!acc[e.currency_id]) {
          acc[e.currency_id] = {
            sum: 0,
            count: 0,
            currency_id: e.currency_id,
            currency_title: this.$AllCurrencies[e.currency_id]?.currency
          };
        }
        if (e.affect_saldo) {
          acc[e.currency_id].sum += (e?.sum ?? 0);
          acc[e.currency_id].count++;
        }
        return acc;
      }, {});
    },
    updateType(e, index) {
      this.editExpenses[index].pass_type = e.target.checked === true ? 2 : 1;
    },
    cloneExpenses() {
      this.editExpenses = [];
      if (this.expenses) {
        this.expenses.forEach(e => {
          if (!e.affect_saldo) return;
          this.editExpenses.push({
            ...e,
            to_delete: false,
            disabled: (+this.division === 0 && e.store_id !== 0) || (this.$currentUID !== e.user_id && this.$currentRole !== 'admin') || (this.$currentRole !== 'admin' && !!e.is_confirmed)
          })
        });
      }
    },
    async getTypes() {
      // const {data} = await api.index('/reports/expenses/types');
    },
    async save() {
      if (!this.editExpenses || !this.editExpenses.length) return;
      if (this.editExpenses.find(e => e.sum && !e.type_id)) {
        toastr["warning"]("Выберите тип расхода");
        return;
      }
      this.loading = true;
      const {data} = await api.post("/reports/updateReport", {
        type: "expenses",
        records: this.editExpenses,
        division: this.division,
        date: this.date
      });

      if (data.success) {
        if (this.updateExpenses) {
          this.updateExpenses(data.records);
        }
        toastr["success"]("Сохранено!");
      } else {
        toastr["warning"](data.message || "Ошибка!");
      }
      this.loading = false;
    },
    addNew() {
      this.editExpenses.push({
        id: null,
        sum: 0,
        type_id: 0,
        currency_id: 33,
        pass_type: 1,
        extra_data: {
          period: 1,
          period_type: 'month'
        },
        comment: null,
        user_id: (this.chiefRunners ?? []).length > 1 ? null : this.userId,
        to_delete: false,
        is_confirmed: this.notConfirmedExpenses ? 0 : 1
      });
    }
  }
};
</script>

<style scoped>
@media (max-width: 576px) {
  .block {
    padding: 10px 5px !important;
    border: 1px solid lightgray;
    margin: 0 -3px;
    margin-bottom: 10px;
    background-color: #fcfafa;
  }
}

.row select,
.row input,
.row button {
  border-radius: 0;
}

i {
  text-align: center;
}

.row {
  padding: 2px 16px;
}

.row p {
  font-size: 10px;
  margin-bottom: 2px;
}

.created_info {
  min-width: 160px;
  width: 160px;
  padding-right: 5px;
  padding-top: 5px;
}

.created_info .text-muted {
  font-size: 8px;
}

.w_300 {
  width: 300px;
}

.w_120 {
  width: 120px;
}

.w_110 {
  width: 40px;
}

.created_info p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
